import axios from 'axios';
import { IEventModel } from 'entities/Event/Event.models';

const basePath = 'events';

export const eventTransport = {
  getEventModel: (id: number): Promise<IEventModel> => axios.get(`${basePath}/review/${id}`),
};
